/*eslint-disable prefer-const */
/*eslint-disable array-callback-return */
/*eslint-disable linebreak-style */
/*eslint-disable eqeqeq */
/*eslint-disable no-redeclare */
/*eslint-disable no-unused-vars */
import React, { useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Col, Container, Row, Form } from 'react-bootstrap';
import PreferencesSettings from '../PreferencesSettings';
import '../preference.scss';
import './timezone.scss';
import 'react-toastify/dist/ReactToastify.css';
import { ToastContainer, toast } from 'react-toastify';
import { Loader } from 'semantic-ui-react';
import { useTranslation } from 'react-i18next';
import ToastMessage from '../../common/ToastMessage';
import { axiosInstance } from 'src/api/axios';
import APIEndpoints from 'src/Admin/api/APIEndpoints';
import {
  HttpErrorCodes,
  HttpSuccessCodes,
} from '../../../errorhandling/HttpErrorCodes';
import moment from 'moment';
import AutoSuggestionSelectComponent from '../../common/auto-suggestion-select/Select';
import { setAppConfig } from '../../../../redux/app/appSlice';

import { CreateAdminConfig } from '../../../utils/common';
import GenericButton from '../../../../Components/GenericButton/GenericButton';
import MasterPermissions from '../../../api/MasterPermissions';

export default function TimeZoneDateFormat(props) {
  const { Default_Time_Format } =
    useSelector((state) => state.app?.appConfigs?.Time_Setting) || {};
  const { appConfigs } = useSelector((state) => state.app) || {};
  const { DATE_FORMAT_OPTIONS } = useSelector(
    (state) => state.app?.appDefinations,
  );
  const [dateFormat, setDateFormat] = useState({
    label: Default_Time_Format,
    value: Default_Time_Format,
  });
  const [updatedAppConfigs, setupdatedAppConfigs] = useState(appConfigs);
  const dispatch = useDispatch();

  const { t } = useTranslation();

  const onChangeHandler = (selectedValue) => {
    setupdatedAppConfigs((current) => {
      //👇️ using spread syntax (...)

      return {
        ...current,
        Time_Setting: {
          ...current.Time_Setting,

          //👇️ override value for nested country property
          Default_Time_Format: selectedValue.value,
        },
      };
    });

    setDateFormat(selectedValue);
  };

  const updateTimeAndDate = async () => {
    const saveJson = CreateAdminConfig(updatedAppConfigs);
    return await axiosInstance.put(
      APIEndpoints.putUpdateConfiguration(),
      JSON.stringify(saveJson),
    );
  };
  const handleSubmit = async () => {
    try {
      const response = await updateTimeAndDate();
      if (HttpSuccessCodes.HTTP_SUCCESS_CODE_200 === response.status) {
        dispatch(setAppConfig(updatedAppConfigs));
      }
      toast.success(
        <ToastMessage
          type="success"
          subTitle={'Updated Date format successfully'}
        />,
      );
    } catch (error) {
      console.log(error);
      if (error.toString().includes('409')) {
        toast.warning(
          <ToastMessage
            type="warning"
            subTitle={
              'No changes were made! Select another date format and try again.'
            }
          />,
        );
      } else {
        toast.error(
          <ToastMessage
            type="error"
            subTitle={'Date format updation failed'}
          />,
        );
      }
    }
  };

  const DATE_FORMAT_OPTIONS_DISABLED =
    DATE_FORMAT_OPTIONS &&
    DATE_FORMAT_OPTIONS.map((option) => ({
      ...option,
      isdisabled: true,
    }));

  return !Default_Time_Format && !DATE_FORMAT_OPTIONS ? (
    <span className="maintain_datetime">
      Please define date format and time zone in app defination
    </span>
  ) : (
    <div>
      <Container className="mtop30 activationCode m-0 time-zone-preference">
        {/*<h2>Time Zone</h2> */}

        <Form>
          {/*<Row>
            <Col md={8} lg={8} sm={8}> */}
          {/*<Form.Group controlId="formBasicCheckbox" className="mb-4">
                <Row>

                  <Form.Check type="checkbox" />

                  <Col className="p-0">
                    <Form.Label id="checkbox_style">
                    Allow to maintain Time Zone in the Member Portal
                    </Form.Label>
                    <p className="p-0 m-0">
                      <span className="maintain_timezone">Members would be allowed to maintain Time Zone</span><br></br>
                      <span className="maintain_timezone">in Preference Setting in the Member Portal</span>
                    </p>
                  </Col>
                </Row>
              </Form.Group> */}

          {/*<Form.Group controlId="formBasicTimeZone" className="timezone-margin">
                <Form.Label className="text-format" >
                  Default Time Zone
                </Form.Label>
                <Row>
                  <Col>
                    {/*<Form.Control as="select">
                      <option>Eastern Standard Time (EST)</option>
                      <option>Central Standard Time (CST) (UTC-6)</option>
                    </Form.Control> */}
          <h2>Date Format</h2>
          <Row>
            <Col md={8} lg={8} sm={8}>
              <Row className="mb-4">
                <Col>
                  {' '}
                  <span className="maintain_datetime">
                    Define the default date format, Member can change the
                    default date format in preference setting.
                  </span>
                </Col>
              </Row>
              <Form.Group
                controlId="formBasicDateFormat"
                className="timezone-margin mb-4"
              >
                <Form.Label className="text-format">Date Format</Form.Label>
                <Row>
                  <Col md={6}>
                    <AutoSuggestionSelectComponent
                      /*options={
                        MasterPermissions.CheckPermission( 'Edit System Preference' ) ?
                        DATE_FORMAT_OPTIONS :
                        DATE_FORMAT_OPTIONS_DISABLED
                      }*/
                      options={DATE_FORMAT_OPTIONS}
                      components={{ IndicatorSeparator: () => null }}
                      inputClassName="coverage-for-filter height-32"
                      value={dateFormat}
                      onChange={onChangeHandler}
                      isSearchable={false}
                      isDisabled={
                        !MasterPermissions.CheckPermission(
                          'Edit System Preference',
                        )
                      }
                    />
                  </Col>
                </Row>
                <span className="example-text1 d-inline-block pt-4">
                  Example: {moment('05-12-2021').format(dateFormat.value)}
                </span>
              </Form.Group>
            </Col>
          </Row>
          {/*<p>&nbsp;</p> */}
        </Form>

        <Row>
          <Col>
            <GenericButton
              onClick={handleSubmit}
              className="ml-1"
              disable={
                !MasterPermissions.CheckPermission('Edit System Preference')
              }
              buttonDisabled={
                !MasterPermissions.CheckPermission('Edit System Preference')
              }
            >
              SAVE
            </GenericButton>
          </Col>
        </Row>
      </Container>
    </div>
  );
}
